import fake from '../../fake';

export default (BASE_URL) => ({
  loadSets: function() {
    // GET /api/:projectId/marks
    return new Promise((res, rej) => {
      setTimeout(() => {
        res(fake.projects.sets);
      }, 1000);
    });
  },
});
